const noopCloseRequested = () => undefined;

const DEFAULT_TOOLTIP_DISTANCE = 8;

export const tooltipFlyoutDefaults = {
    hasArrow: true,
    offset: {
        distance: DEFAULT_TOOLTIP_DISTANCE,
    },
    onCloseRequested: noopCloseRequested,
} as const;

export const ANIMATION_DURATION = 500;
